import apiClient from './api.client'

export interface LoginRequest {
  email: string
  password: string
}

export interface RegisterRequest {
  email: string
  username: string
  password: string
}

export interface AuthUser {
  id: string
  email: string
  username: string
  avatar?: string
  role: string
}

export interface AuthResponse {
  success: boolean
  data?: {
    user: AuthUser
    token: string
  }
  error?: string
}

export const authService = {
  async login(data: LoginRequest): Promise<AuthResponse> {
    const response = await apiClient.instance.post<AuthResponse>('/api/auth/login', data)
    if (response.data.success && response.data.data?.token) {
      localStorage.setItem('token', response.data.data.token)
      localStorage.setItem('user', JSON.stringify(response.data.data.user))
    }
    return response.data
  },

  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response = await apiClient.instance.post<AuthResponse>('/api/auth/register', data)
    return response.data
  },

  async me(): Promise<AuthUser | null> {
    const response = await apiClient.instance.get<{ success: boolean; data: AuthUser }>('/api/auth/me')
    return response.data.success ? response.data.data : null
  },

  async logout(): Promise<void> {
    await apiClient.instance.post('/api/auth/logout')
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  },

  getUser(): AuthUser | null {
    const userStr = localStorage.getItem('user')
    return userStr ? JSON.parse(userStr) : null
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token')
  },
}
